// extracted by mini-css-extract-plugin
export var aircallIframe = "_la-3";
export var fabContainer = "_la-5";
export var fabRinging = "_la-6";
export var loadingOverlay = "_la-4";
export var pulse = "_la-7";
export var widgetContent = "_la-2";
export var widgetPanel = "_la-0";
export var widgetPanelExpanded = "_la-1";